import { BadgeProps } from '@components/primitives';

import { Invoice, PlanNameType, UsageType } from './types';

const LABELS: Record<UsageType, string> = {
  fieldDecrypts: 'Decrypts',
  fileDecrypts: 'File Decrypts',
  fieldRedacts: 'Field Redactions',
  tdsSessions: '3D Secure Sessions',
  networkTokenEvents: 'Network Token Events',
  binLookups: 'BIN Lookups',
};

export function labelForUsageType(type: UsageType) {
  return LABELS[type] || type;
}

const PLAN_LABELS: Record<PlanNameType, string> = {
  free: 'Free',
  pro: 'Platform',
  enterprise: 'Custom',
  legacy: 'Legacy',
};

export function labelForPlan(plan: PlanNameType): string {
  return PLAN_LABELS[plan] || plan;
}

const INVOICE_STATUS_LABELS: Record<Invoice['status'], string> = {
  open: 'Unpaid',
  cancelled: 'Cancelled',
  upcoming: 'Upcoming',
  pending_approval: 'Pending approval',
  scheduled: 'Scheduled',
  processing: 'Processing',
  issued: 'Unpaid',
  void: 'Void',
  paid: 'Paid',
  canceled: 'Cancelled',
  overdue: 'Overdue',
};

export function labelForInvoiceStatus(status: Invoice['status']): string {
  return INVOICE_STATUS_LABELS[status] || status;
}

const INVOICE_STATUS_VARIANTS: Record<
  Invoice['status'],
  NonNullable<BadgeProps['variant']>
> = {
  paid: 'success',
  open: 'warning',
  issued: 'warning',
  overdue: 'red',
  cancelled: 'muted',
  canceled: 'muted',
  void: 'muted',
  upcoming: 'outline',
  scheduled: 'outline',
  pending_approval: 'outline',
  processing: 'outline',
};

export function variantForInvoiceStatus(
  status: Invoice['status']
): NonNullable<BadgeProps['variant']> {
  return INVOICE_STATUS_VARIANTS[status] ?? 'primary';
}
